/** Mapa campo → primeira mensagem (para Field.error). */
export function fieldErrorsFromZod(error) {
    const out = {};
    for (const issue of error.issues) {
        const key = issue.path.join(".") || "_form";
        if (!out[key])
            out[key] = issue.message;
    }
    return out;
}
export function firstZodMessage(error) {
    return error.issues[0]?.message ?? "Dados inválidos";
}
//# sourceMappingURL=zod-errors.js.map